/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { TbMessageCircle } from "react-icons/tb";
import { FaChevronDown, FaChevronUp, FaFileAlt, FaUserTie, FaBriefcase, FaShoppingBag, FaIdCard, FaFileDownload } from "react-icons/fa";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import "../../../css/Pages/Pages.css";
import { userDataActionCreators } from "../../../service/action-creators";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import Loader from "../../Loader";
import Modal from "../../Modal/Modal";
import NotFoundComponent from "../../NotFoundComponent";
import RenderHome from "../home/RenderHome";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from "../../../service/axios/axios";

function MyOrdersNdPurchases() {
  const dispatch = useDispatch();
  const history = useHistory();
  const device = () => window.innerWidth < 1080;

  const {
    GetMyOrders,
    GetAppliedOrderDetailed,
    DeleteMyAppliedOrder,
    GetCartProducts,
    ResetUserDataResponse,
  } = bindActionCreators(userDataActionCreators, dispatch);

  const orders = useSelector((state) => state.user?.orders);
  const isLoading = useSelector((state) => state.user?.isLoading);
  const response = useSelector((state) => state?.user?.response);
  const orderDetailed = useSelector((state) => state?.user?.order);
  const user = useSelector((state) => state?.auth?.user);
  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [messageEditDetailed, setMessageEditDetailed] = useState("");
  const [downloadingReceipt, setDownloadingReceipt] = useState(null);
  const [isMobile, setIsMobile] = useState(device);

  useEffect(() => {
    dispatch(GetUserProfile());
    GetMyOrders();
    dispatch(GetNotifications());
    GetCartProducts();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => setIsMobile(device));
    return () => {};
  }, []);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      GetMyOrders();
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state]);

  // Streams the hire-purchase receipt PDF from the API and saves it locally.
  const handleDownloadReceipt = async (order) => {
    setDownloadingReceipt(order?._id);
    try {
      const res = await axiosInstance.get(`/orders/user/hp-receipt/${order?._id}`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `UPNMG-Hire-Purchase-Receipt-${String(order?.name || user?.name || "order").replace(/[^a-z0-9-_]+/gi, "_")}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error("Could not download the receipt. Please try again.");
    } finally {
      setDownloadingReceipt(null);
    }
  };

  const handleTogglePreview = (orderId) => {
    if (expandedOrderId === orderId) {
      setExpandedOrderId(null);
    } else {
      GetAppliedOrderDetailed(orderId);
      setExpandedOrderId(orderId);
    }
  };

  /* --- Shared inline styles --- */
  const cardStyle = {
    background: "#fff",
    borderRadius: "0.75rem",
    border: "1px solid #e5e7eb",
    marginBottom: "1rem",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    overflow: "hidden",
  };

  const cardHeader = {
    padding: "1.25rem",
  };

  const statusDot = (active, isRejected) => ({
    width: "14px",
    height: "14px",
    borderRadius: "50%",
    background: active ? (isRejected ? "#ef4444" : "#16a34a") : "#d1d5db",
    flexShrink: 0,
  });

  const statusLine = (active) => ({
    flex: 1,
    height: "3px",
    background: active ? "#16a34a" : "#e5e7eb",
    margin: "0 0.25rem",
  });

  const dropdownBody = {
    borderTop: "1px solid #e5e7eb",
    background: "#fafbfc",
    padding: "1.25rem",
  };

  const sectionTitle = {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#1f2937",
    marginBottom: "0.75rem",
    paddingBottom: "0.5rem",
    borderBottom: "1px solid #e5e7eb",
  };

  // One grid for every section so columns line up down the whole panel. The
  // old mix of 2-col and auto-fit rows produced ragged, uneven columns.
  const fieldGrid = {
    display: "grid",
    gridTemplateColumns: isMobile ? "repeat(2, minmax(0, 1fr))" : "repeat(3, minmax(0, 1fr))",
    gap: "0.85rem 1rem",
  };

  const sectionBlock = {
    marginBottom: "1.25rem",
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "0.6rem",
    padding: "1rem",
  };

  const fieldLabel = {
    fontSize: "0.7rem",
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    marginBottom: "0.15rem",
    fontWeight: 500,
  };

  const fieldValue = {
    fontSize: "0.88rem",
    fontWeight: 600,
    color: "#1f2937",
    wordBreak: "break-word",
  };

  // `monthly_payment` is only stored on newer orders. For everything else the
  // monthly figure lives on each cart item as `period_price`, so derive it the
  // same way the backend report does: sum(period_price x qty).
  const resolveMonthlyDeduction = (order) => {
    if (order?.monthly_payment != null && order?.monthly_payment !== "") {
      return `GH₵ ${Number(order.monthly_payment).toFixed(2)}`;
    }
    const items = Array.isArray(order?.order) ? order.order : [];
    let monthly = 0;
    let hasPeriodPrice = false;
    items.forEach((it) => {
      if (it?.period_price != null) {
        monthly += Number(it.period_price) * Number(it?.qty ?? it?.quantity ?? 1);
        hasPeriodPrice = true;
      }
    });
    return hasPeriodPrice ? `GH₵ ${monthly.toFixed(2)}` : "N/A";
  };

  // Cart items denormalise the product's `images` array onto `product_img`;
  // the newer non-member flow uses a flat `image` string instead.
  const resolveItemImage = (item) => {
    const img = item?.product_img?.[0];
    return (
      item?.image ||
      (typeof img === "string" ? img : img?.url) ||
      "/images/dev/default-image-1.png"
    );
  };

  // `span` lets long values (addresses, emails) take the full row instead of
  // being squeezed into one narrow column and wrapping mid-word.
  const FieldItem = ({ label, value, span }) => (
    <div style={span ? { gridColumn: "1 / -1" } : undefined}>
      <div style={fieldLabel}>{label}</div>
      <div style={fieldValue}>{value || "N/A"}</div>
    </div>
  );

  // Both guarantors carry the same fields, the second suffixed with "2".
  const renderGuarantor = (order, n) => {
    const s = n === 2 ? "2" : "";
    return (
      <div style={sectionBlock}>
        <div style={sectionTitle}>
          <FaUserTie style={{ color: "#6366f1" }} /> Guarantor {n}
        </div>
        <div style={fieldGrid}>
          <FieldItem label="Name" value={order?.[`guarantor_name${s}`]} span />
          <FieldItem label="Staff ID" value={order?.[`guarantor_staff_id${s}`]} />
          <FieldItem label="Phone" value={order?.[`guarantor_phone${s}`]} />
          <FieldItem label="Relationship" value={order?.[`guarantor_relationship${s}`]} />
          <FieldItem label="Ghana Card" value={order?.[`guarantor_ghana_card${s}`]} />
          <FieldItem label="Occupation" value={order?.[`guarantor_occupation${s}`]} />
          <FieldItem label="GPS Address" value={order?.[`guarantor_gps${s}`]} />
          <FieldItem label="Mandate Number" value={order?.[`guarantor_mandate_number${s}`]} />
          <FieldItem label="OTP Number" value={order?.[`guarantor_otp_number${s}`]} />
        </div>
      </div>
    );
  };

  const toggleBtnStyle = (isExpanded) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "0.35rem",
    padding: "0.4rem 0.85rem",
    background: isExpanded ? "#62CA91" : "#058740",
    color: "#fff",
    border: "none",
    borderRadius: "0.4rem",
    cursor: "pointer",
    fontSize: "0.78rem",
    fontWeight: 500,
  });

  const renderStatusTracker = (order) => {
    const stages = [
      { key: "submitted", label: "Submitted" },
      { key: "initiated", label: "Initiated" },
      { key: "approved", label: "Approved" },
      { key: "shipping", label: "Shipped" },
    ];
    const isRejected = order?.rejected?.[0]?.status;

    if (isMobile) {
      const allStages = [...stages];
      if (order?.status !== "paid") {
        allStages.push({ key: "rejected", label: "Rejected" });
      }

      return (
        <div style={{ display: "flex", flexDirection: "column", padding: "0.1rem 0" }}>
          {allStages.map((stage, i) => {
            const isLastStage = i === allStages.length - 1;
            const isRejectedStage = stage.key === "rejected";
            const stageData = isRejectedStage ? order?.rejected?.[0] : order?.[stage.key]?.[0];
            const active = stageData?.status;
            const dotColor = isRejectedStage ? (active ? "#ef4444" : "#d1d5db") : (active ? "#16a34a" : "#d1d5db");
            const lineColor = active ? (isRejectedStage ? "#ef4444" : "#16a34a") : "#e5e7eb";

            return (
              <div key={stage.key} style={{ display: "flex", gap: "0.65rem", alignItems: "flex-start" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "14px", flexShrink: 0 }}>
                  <div style={{ width: "14px", height: "14px", borderRadius: "50%", background: dotColor, flexShrink: 0 }} />
                  {!isLastStage && (
                    <div style={{ width: "2px", flex: 1, minHeight: "40px", background: lineColor }} />
                  )}
                </div>
                <div
                  style={{ paddingBottom: isLastStage ? 0 : "0.9rem", cursor: isRejectedStage && active ? "pointer" : "default" }}
                  onClick={() => {
                    if (isRejectedStage && active) { setMessageEditDetailed(order); setOpenMessageModal(true); }
                  }}
                >
                  <div style={{ fontSize: "0.88rem", fontWeight: 600, color: isRejectedStage ? (active ? "#ef4444" : "#9ca3af") : (active ? "#16a34a" : "#9ca3af") }}>
                    {stage.label}
                  </div>
                  <div style={{ fontSize: "0.75rem", color: "#9ca3af" }}>
                    {active ? moment(stageData.date).format("MMM Do, YY") : "—"}
                  </div>
                  {isRejectedStage && active && (
                    <div style={{ fontSize: "0.75rem", color: "#ef4444", display: "flex", alignItems: "center", gap: "0.2rem", marginTop: "0.1rem" }}>
                      <TbMessageCircle /> Read
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div>
        <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem", padding: "0 0.25rem" }}>
          {stages.map((stage, i) => {
            const active = order?.[stage.key]?.[0]?.status;
            return (
              <React.Fragment key={stage.key}>
                <div style={statusDot(active, false)} title={stage.label} />
                {i < stages.length - 1 && <div style={statusLine(active)} />}
              </React.Fragment>
            );
          })}
          {order?.status !== "paid" && (
            <>
              <div style={statusLine(false)} />
              <div style={statusDot(isRejected, true)} title="Rejected" />
            </>
          )}
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          {stages.map((stage) => {
            const stageData = order?.[stage.key]?.[0];
            return (
              <div key={stage.key} style={{ textAlign: "center", flex: 1, minWidth: "50px" }}>
                <div style={{ fontSize: "0.90rem", fontWeight: 600, color: stageData?.status ? "#16a34a" : "#9ca3af", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={stage.label}>{stage.label}</div>
                <div style={{ fontSize: "0.6rem", color: "#9ca3af" }}>{stageData?.status ? moment(stageData.date).format("MMM Do YY") : "—"}</div>
              </div>
            );
          })}
          {order?.status !== "paid" && (
            <div
              style={{ textAlign: "center", flex: 1, minWidth: "50px", cursor: isRejected ? "pointer" : "default" }}
              onClick={() => {
                if (isRejected) { setMessageEditDetailed(order); setOpenMessageModal(true); }
              }}
            >
              <div style={{ fontSize: "0.75rem", fontWeight: 600, color: isRejected ? "#ef4444" : "#9ca3af" }}>Rejected</div>
              <div style={{ fontSize: "0.75rem", color: isRejected ? "#ef4444" : "#9ca3af" }}>{isRejected ? moment(order.rejected[0].date).format("MMM Do YY") : "—"}</div>
              {isRejected && (
                <div style={{ fontSize: "0.75rem", color: "#ef4444", display: "flex", alignItems: "center", justifyContent: "center", gap: "0.2rem", marginTop: "0.15rem" }}>
                  <TbMessageCircle /> Read
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderOrderDropdown = (order) => {
    const isThisExpanded = expandedOrderId === order?._id;
    const data = isThisExpanded ? orderDetailed : null;

    if (!isThisExpanded) return null;

    return (
      <div style={dropdownBody}>
        {isLoading && !data ? (
          <div style={{ textAlign: "center", padding: "1.5rem" }}><Loader /></div>
        ) : data ? (
          <div>
            {/* Personal Information */}
            <div style={sectionBlock}>
              <div style={sectionTitle}><FaFileAlt style={{ color: "#6366f1" }} /> Personal Information</div>
              <div style={fieldGrid}>
                <FieldItem label="Full Name" value={data?.name || user?.name} span />
                <FieldItem label="Date of Birth" value={data?.dateOfBirth} />
                <FieldItem label="Age" value={data?.age} />
                <FieldItem label="Gender" value={data?.gender} />
                <FieldItem label="SSNIT" value={data?.ssnit} />
                <FieldItem label="ID Type" value={data?.IdCardType} />
                <FieldItem label="ID Number" value={data?.IDCardNumber} />
                <FieldItem label="Phone" value={data?.personal_phone} />
                <FieldItem label="Work Phone" value={data?.work_phone} />
                <FieldItem label="Email" value={data?.email} span />
                <FieldItem
                  label="Residential Address"
                  value={[data?.residential_address1, data?.residential_address2].filter(Boolean).join(", ")}
                  span
                />
                <FieldItem
                  label="Work Address"
                  value={[data?.work_address1, data?.work_address2].filter(Boolean).join(", ")}
                  span
                />
              </div>
            </div>

            {/* Guarantors */}
            {renderGuarantor(data, 1)}
            {data?.guarantor_name2 && renderGuarantor(data, 2)}

            {/* Employment */}
            <div style={sectionBlock}>
              <div style={sectionTitle}><FaBriefcase style={{ color: "#6366f1" }} /> Employment Details</div>
              <div style={fieldGrid}>
                <FieldItem label="Employer" value={data?.employer_name} span />
                <FieldItem label="Facility" value={data?.facility} />
                <FieldItem label="Staff ID" value={data?.staff_id} />
                <FieldItem label="Occupation" value={data?.occupation} />
                <FieldItem label="Region" value={user?.region} />
                <FieldItem label="Employer Location" value={data?.employer_location} />
                <FieldItem label="Start Date" value={data?.employment_start_date} />
              </div>
            </div>

            {/* Order Details */}
            <div style={sectionBlock}>
              <div style={sectionTitle}><FaShoppingBag style={{ color: "#6366f1" }} /> Order Details</div>
              <div style={fieldGrid}>
                <FieldItem label="Mandate Number" value={data?.mandate_number} />
                <FieldItem label="OTP Number" value={data?.otp_number} />
                <FieldItem label="Monthly Deduction" value={resolveMonthlyDeduction(data)} />
                <FieldItem label="Duration" value={data?.duration ? `${data.duration} months` : ""} />
                <FieldItem
                  label="Total Repayable"
                  value={data?.total_repayable ? `GH₵ ${Number(data.total_repayable).toFixed(2)}` : ""}
                />
                <FieldItem
                  label="Grand Total"
                  value={data?.grand_total ? `GH₵ ${Number(data.grand_total).toFixed(2)}` : ""}
                />
              </div>
              {data?.order?.length > 0 && (
                <div style={{ marginTop: "0.75rem" }}>
                  <div style={{ ...fieldLabel, marginBottom: "0.5rem" }}>Products</div>
                  <div style={{ display: "grid", gap: "0.5rem" }}>
                    {data.order.map((item, i) => {
                      const image = resolveItemImage(item);
                      const price = item?.product_price ?? item?.price;
                      const qty = item?.qty ?? item?.quantity ?? 1;
                      const period = item?.period ?? data?.duration;
                      return (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                            padding: "0.5rem",
                            background: "#fff",
                            borderRadius: "0.4rem",
                            border: "1px solid #e5e7eb",
                          }}
                        >
                          <img
                            src={image}
                            alt={item?.product_name || "Product"}
                            onError={(e) => {
                              e.currentTarget.src = "/images/dev/default-image-1.png";
                            }}
                            style={{ width: "50px", height: "50px", borderRadius: "0.3rem", objectFit: "cover", background: "#f3f4f6", flexShrink: 0 }}
                          />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: "0.82rem", fontWeight: 600, color: "#1f2937" }}>
                              {item?.product_name || "Product"}
                            </div>
                            <div style={{ fontSize: "0.72rem", color: "#6b7280" }}>
                              Qty: {qty}
                              {price ? ` | GH₵ ${price}` : ""}
                              {period ? ` | ${period} months` : ""}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            {/* Bank Details — the order flow doesn't capture these today, so the
                section only renders if a bank field is actually present. */}
            {(data?.bank_account_holder_name ||
              data?.bank_name ||
              data?.bank_account_number ||
              data?.bank_branch) && (
            <div style={sectionBlock}>
              <div style={sectionTitle}><FaBriefcase style={{ color: "#6366f1" }} /> Bank Details</div>
              <div style={fieldGrid}>
                <FieldItem label="Account Holder" value={data?.bank_account_holder_name} span />
                <FieldItem label="Bank Name" value={data?.bank_name} />
                <FieldItem label="Account Number" value={data?.bank_account_number} />
                <FieldItem label="Branch" value={data?.bank_branch} />
              </div>
            </div>
            )}

            {/* ID Card Images */}
            {(data?.frontIDImage || data?.passportImage) && (
              <div style={sectionBlock}>
                <div style={sectionTitle}><FaIdCard style={{ color: "#6366f1" }} /> Uploaded Documents</div>
                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0.75rem" }}>
                  {data?.frontIDImage && (
                    <div>
                      <div style={fieldLabel}>Ghana Card (Front)</div>
                      <div style={{ borderRadius: "0.5rem", border: "1px solid #e5e7eb", overflow: "hidden", height: "160px", background: "#fff" }}>
                        <img src={data.frontIDImage} alt="Front ID" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                      </div>
                    </div>
                  )}
                  {data?.passportImage && (
                    <div>
                      <div style={fieldLabel}>Ghana Card (Back)</div>
                      <div style={{ borderRadius: "0.5rem", border: "1px solid #e5e7eb", overflow: "hidden", height: "160px", background: "#fff" }}>
                        <img src={data.passportImage} alt="Back" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Actions */}
            <div style={{ display: "flex", justifyContent: "center", gap: "0.5rem", marginTop: "0.75rem", flexWrap: "wrap" }}>
              {data?._id && (
                <button
                  type="button"
                  disabled={downloadingReceipt === data?._id}
                  onClick={() => handleDownloadReceipt(data)}
                  style={{
                    padding: "0.45rem 1.5rem",
                    background: downloadingReceipt === data?._id ? "#a5b4fc" : "#6366f1",
                    color: "#fff",
                    border: "none",
                    borderRadius: "0.4rem",
                    cursor: downloadingReceipt === data?._id ? "not-allowed" : "pointer",
                    fontWeight: 500,
                    fontSize: "0.8rem",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.4rem",
                  }}
                >
                  <FaFileDownload />
                  {downloadingReceipt === data?._id ? "Preparing…" : "Download Receipt"}
                </button>
              )}
              <button
                type="button"
                onClick={() => setExpandedOrderId(null)}
                style={{ padding: "0.45rem 1.5rem", background: "#e5e7eb", color: "#374151", border: "none", borderRadius: "0.4rem", cursor: "pointer", fontWeight: 500, fontSize: "0.8rem", display: "flex", alignItems: "center", gap: "0.3rem" }}
              >
                <FaChevronUp /> Collapse
              </button>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "1.5rem", color: "#9ca3af" }}>No order data available</div>
        )}
      </div>
    );
  };

  return (
    <div className="MyOrdersNdPurchases">
      <RenderHome>
        {isLoading && <Loader />}
        <div style={{ maxWidth: "2000px", margin: "0 auto", padding: "1rem" }}>
          <h3 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#1f2937", marginBottom: "1.25rem" }}>
            My Orders
          </h3>

          {orders?.length > 0 ? (
            <div>
              {orders?.map((order, index) => {
                const isExpanded = expandedOrderId === order?._id;
                const isRejectedWithEdit = order?.rejected?.[0]?.status && (
                  order?.rejected?.[0]?.editFormChecked ||
                  order?.rejected?.[0]?.editFormAndProductChecked
                );
                return (
                  <div key={index} style={cardStyle}>
                    <div style={cardHeader}>
                      {/* Header row */}
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem", flexWrap: "wrap", gap: "0.5rem" }}>
                        <div>
                          <div style={{ fontSize: "0.7rem", color: "#6b7280", textTransform: "uppercase", marginBottom: "0.15rem" }}>Order #{index + 1}</div>
                          <div style={{ fontSize: "0.85rem", fontWeight: 600, color: "#1f2937" }}>
                            {order?.submitted?.[0]?.status ? moment(order?.submitted?.[0]?.date).format("MMMM Do, YYYY") : "Pending"}
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            if (isRejectedWithEdit) {
                              history.push({ pathname: "/edit-order-form", search: `?order_id=${order?._id}` });
                            } else {
                              handleTogglePreview(order?._id);
                            }
                          }}
                          style={isRejectedWithEdit
                            ? { ...toggleBtnStyle(false), background: "#dc2626" }
                            : toggleBtnStyle(isExpanded)}
                        >
                          {isRejectedWithEdit ? null : (isExpanded ? <FaChevronUp /> : <FaChevronDown />)}
                          {isRejectedWithEdit ? "Edit Rejected Application" : (isExpanded ? "Hide" : "Preview")}
                        </button>
                      </div>
                      {/* Status tracker */}
                      {renderStatusTracker(order)}
                    </div>

                    {/* Expandable dropdown */}
                    {renderOrderDropdown(order)}
                  </div>
                );
              })}
            </div>
          ) : (
            <NotFoundComponent title={"No orders available"} />
          )}
        </div>

        {/* Rejection Message Modal */}
        {openMessageModal && (
          <Modal
            title={"Rejected Message"}
            width={isMobile ? "85%" : "35%"}
            closeModal={setOpenMessageModal}
          >
            <div className="modalBody">
              <div className="message">
                <p>{messageEditDetailed?.rejected[0]?.message}</p>
                {(messageEditDetailed?.rejected[0]?.editFormChecked ||
                  messageEditDetailed?.rejected[0]?.editFormAndProductChecked) && (
                  <button
                    onClick={() =>
                      history.push({
                        pathname: "/edit-order-form",
                        search: `?order_id=${messageEditDetailed?._id}`,
                      })
                    }
                    type="button"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 mt-4 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                  >
                    Click here to edit form
                  </button>
                )}
              </div>
            </div>
            <div className="modalButton">
              <div className="btnCover">
                <button type="button" onClick={() => setOpenMessageModal(false)} className="cancelBtn">Close</button>
              </div>
            </div>
          </Modal>
        )}
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default MyOrdersNdPurchases;
